// extracted by mini-css-extract-plugin
module.exports = {"container":"text-to-speech-controls_container_uun"};